const Equa = {
  symbol: 'equa',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm.72-21.922c3.093-.606 3.265 1.471 3.265 1.471.172 2.337-1.805 2.424-1.805 2.424l-.582.04c-.91.027-1.672.7-1.818 1.604a1.922 1.922 0 0 0 .413 1.527c.35.425.866.677 1.414.69l.573.033c4.126-.26 5.33-3.635 5.33-3.635 1.719-4.24-1.634-6.837-1.634-6.837-2.505-1.967-5.39-1.493-7.36-.756a10.172 10.172 0 0 0-4.278 3.072c-4.794 5.812-.395 12.137-.395 12.137 2.246 3.044 5.707 4.31 8.286 4.136a2.014 2.014 0 0 0 1.856-2.022c0-.538-.212-1.054-.59-1.434a2.007 2.007 0 0 0-1.424-.594h-.258a4.36 4.36 0 0 1-1.113-.143c-5.246-1.386-4.608-6.52-4.608-6.52.601-4.587 4.727-5.193 4.727-5.193z"/>`;
  },
  colorIcon() {
    return `<g fill="none"><circle cx="16" cy="16" r="16" fill="#F68922"/><path fill="#FFF" d="M16.72 10.078s-4.127.606-4.728 5.193c0 0-.638 5.134 4.608 6.52a4.36 4.36 0 0 0 1.113.143h.258c.534 0 1.046.214 1.424.594.378.38.59.896.59 1.434a2.014 2.014 0 0 1-1.856 2.022c-2.579.174-6.04-1.092-8.286-4.136 0 0-4.399-6.325.395-12.137a10.172 10.172 0 0 1 4.277-3.072c1.97-.737 4.856-1.211 7.361.756 0 0 3.353 2.597 1.634 6.837 0 0-1.204 3.375-5.33 3.635l-.573-.032a1.895 1.895 0 0 1-1.414-.691 1.922 1.922 0 0 1-.413-1.527 1.904 1.904 0 0 1 1.818-1.605l.582-.04s1.977-.086 1.805-2.423c0 0-.172-2.077-3.266-1.47"/></g>`;
  }
};
export default Equa;



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cryptoicon/src/icons/equa.js
// module id = null
// module chunks = 